import { _getV1, _postV1 } from './config/index'
import { IncomingFormPayload } from '../types/payloads.users'
import { User } from '../types/user'
import { PreferenceKeys,PreferencesType } from '../types/preferenceKeys'

export type WipeAccountData = {
  deleteReason: string
  extraDetails: string
}

export async function getUserById(userToId: string): Promise<User> {
  try {
    const response = await _getV1(`/getUser/${userToId}`, {})
    return response.data
  } catch (error: any) {
    console.log('Error on GET getUser:', error)
    throw error
  }
}

export async function getRandomUserId() : Promise<string | null> {
  try {
    const response = await _getV1('/getRandomUserId',{},{ 404:{ 'data':null } })
    return response.data
  } catch (error: any) {
    console.log('Error on GET getRandomUserId:', error)
    throw error
  }
}

export const getCurrentUser = async () : Promise<User> => (await _getV1('/getCurrentUser',{})).data

export const updateProfile = async (payload:IncomingFormPayload) : Promise<any> => {
  return (await _postV1('/updateProfile',payload)).data
}

export async function createUser(toNumber: string, countryCode: string): Promise<any> {
  try {
    const response = await _postV1('/createUser', { emailPhone: toNumber, countryCode: countryCode })
    return response
  } catch (error: any) {
    console.log('Error on POST createUser:', error)
    return {
      error: true,
      message: error,
    }
  }
}

export async function wipeUserAccount(wipeAccountData: WipeAccountData, onSuccess:(res: any)=>void, onFail:(e:any)=>void): Promise<any> {
  try {
    const response = await _postV1('/deleteUser', wipeAccountData)
    onSuccess(response)
  } catch (error: any) {
    console.log('Error on POST deleteUser:', error)
    onFail(error)
  }
}

export async function getMyLikes(onSuccess?:(res: any)=>void, onFail?:(e:any)=>void): Promise<any> {
  try {
    const response = await _postV1('/getLikes', {})
    onSuccess && onSuccess(response)
    return response.data
  } catch (error: any) {
    onFail && onFail(error)
    return {
      error: true,
      message: error,
    }
  }
}

export async function updateMyPreferences(userPreferences: PreferencesType, onSuccess?:(res: any)=>void, onFail?:(e:any)=>void): Promise<any> {
  try {
    const response = await _postV1('/updatePreferences', userPreferences)
    onSuccess && onSuccess(response)
  } catch (error: any) {
    onFail && onFail(error)
  }
}

export async function getMyPreferences(onSuccess?:(res: any)=>void, onFail?:(e:any)=>void): Promise<any> {
  try {
    const response = await _getV1('/getPreferences', {})
    onSuccess && onSuccess(response)
    return response
  } catch (error: any) {
    onFail && onFail(error)
    return error
  }
}

export async function requestMediaUrl(mimeType:string,onSuccess?:(res: any)=>void, onFail?:(e:any)=>void): Promise<any> {
  try {
    const response = await _postV1('/requestMediaUrl', {mimeType:mimeType})
    return onSuccess ? await onSuccess(response) : response.data
  } catch (error: any) {
    if(onFail)
    {
      onFail(error)
    }
    return {
      error: true,
      message: error,
    }
  }
}

export async function confirmVerifyUpload(id:string,verifyPhotoId:string,onSuccess:(res:{ token:string | null }) => Promise<void>,onFail?:(e:any)=>void): Promise<void> {
  try {
    const response = await _postV1('/confirmVerifyUpload', {
      id:id,
      verifyPhotoId:verifyPhotoId
    })
    onSuccess(response.data)
  } catch (error: any) {
    onFail && onFail(error)
  }
}

export async function confirmPhotoUpload(id:string,onSuccess?:(res: any)=>void, onFail?:(e:any)=>void): Promise<any> {
  try {
    const response = await _postV1(`/confirmPhotoUpload/${id}`,{})
    return onSuccess ? await onSuccess(response) : response.data
  } catch (error: any) {
    if(onFail){
      onFail(error)
    }
    return {
      error: true,
      message: error,
    }
  }
}

export async function deletePhoto(i:number,onSuccess?:(res: any)=>void, onFail?:(e:any)=>void): Promise<any> {
  try {
    const response = await _postV1(`/deletePhoto/${i}`,{})
    return onSuccess ? await onSuccess(response) : response.data
  } catch (error: any) {
    if(onFail){
      onFail(error)
    }
    return {
      error: true,
      message: error,
    }
  }
}

export async function replacePhoto(i:number,id:string,onSuccess?:(res: any)=>void, onFail?:(e:any)=>void): Promise<any> {
  try {
    const response = await _postV1(`/replace-photo/${i}/${id}`,{})
    return onSuccess ? await onSuccess(response) : response.data
  } catch (error: any) {
    if(onFail){
      onFail(error)
    }
    return {
      'error': true,
      'message': error,
    }
  }
}

export async function swapPhotos(i:number,j:number,onSuccess?:(res: any)=>void, onFail?:(e:any)=>void): Promise<any> {
  try {
    const response = await _postV1(`/swap-photos/${i}/${j}`,{})
    return onSuccess ? await onSuccess(response) : response.data
  } catch (error: any) {
    if(onFail){
      onFail(error)
    }
    return {
      'error': true,
      'message': error,
    }
  }
}

export interface LazyTableState<T> {
  first         : number
  rows          : number
  page          : number
  sortField?    : string
  sortOrder?    : number
  filters       : T
}

export async function getUsers<T>(lazyState: LazyTableState<T>,onSuccess?:(res: any)=>void, onFail?:(e:any)=>void): Promise<{users:User[], total:number}> {
  try {
    const response = await _postV1('/getUsers', {
      first   : lazyState.first,
      rows    : lazyState.rows,
      page    : lazyState.page,
      filters : lazyState.filters,
      // filters : null,
    })
    if(onSuccess){await onSuccess(response)}
    return response.data
  } catch (error: any) {
    if(onFail){
      onFail(error)
      return undefined as unknown as {users:User[], total:number}
    }
    else{
      throw error
    }
  }
}

export async function cancelStripeSubscription(stripeSubId:string,onSuccess:(res: any)=>void, onFail?:(e:any)=>void): Promise<any> {
  try {
    const response = await _postV1(`/cancelStripeSubscription/${stripeSubId}`, {})
    await onSuccess(response)
  } catch (error: any) {
    if(onFail){
      onFail(error)
    }
    return {
      error: true,
      message: error,
    }
  }
}

export async function unsubscribeFromEmails(userId:string|undefined,onSuccess:(res: any)=>void, onFail?:(e:any)=>void): Promise<any> {
  try {
    const response = await _postV1(`/unsubscribe/${userId}`, {})
    await onSuccess(response)
  } catch (error: any) {
    if(onFail){
      onFail(error)
    }
    return {
      error: true,
      message: error,
    }
  }
}
